import React from 'react';
import PropTypes from 'prop-types';
import { IconInfoSign } from '@saucelabs/sl-component-icons';
import { OverlayTrigger, Tooltip } from '@saucelabs/sl-component-overlay';

const DCExplanationTooltip = ({ placement }) => (
  <OverlayTrigger
    overlay={(
      <Tooltip id="dc-info-tooltip">
        <div>
          The purchases shown below are specific to this data center. If you
          purchased sessions in another data center and wish to use those,
          please use the selector to the top-right to switch to that data center.
        </div>
      </Tooltip>
    )}
    placement={placement}
  >
    <IconInfoSign className="inline-flex fill-current ml-0.5" />
  </OverlayTrigger>
);

DCExplanationTooltip.defaultProps = {
  placement: 'right',
};

DCExplanationTooltip.propTypes = {
  placement: PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
};

export default DCExplanationTooltip;
